import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  Table,
  Modal,
  FormControl,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Datetime from "react-datetime";
import Button from "components/CustomButton/CustomButton.jsx";
import {
  UpdateSchedule,
  GetDocAllUser,
  GetSchedule,
} from "../../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../../variables/Variables";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import moment from "moment";
import LoadingSpinner from "views/Components/loadingSpinner";

class EditSchedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      doctors: [],
      sch_tabledata: this.tabledata,
      sel_docotor: "",
      sel_docotor_name: "",
      iserror: false,
      iserrorHoliday: false,
      manageslotsshow: false,
      iserrorSchdule: false,
      timeslots: this.tabledata_dis,
      currentslot: "",
      doc_error: null,
      date_values_cum: [],
      is_add: false,
      glbSchdule: [],
      holiday_day: new Date(),
      holiday_day_err: "",
      isHoliday: "",
      isHallMark: "",
      isCom_err: "",
      currentSch: "",
      isallweekdays: false,
    };
    this.onChange = this.onChange.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleAllCheckedSlot = this.handleAllCheckedSlot.bind(this);
    this.submitCancelOrderModal = this.submitCancelOrderModal.bind(this);
    this.closeCancelOrderModal = this.closeCancelOrderModal.bind(this);
    this.onSubmitfinal = this.onSubmitfinal.bind(this);
    this.editSlot = this.editSlot.bind(this);
    this.addtimeslot = this.addtimeslot.bind(this);
  }

  handleSuccess(dv_type, position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";

    if (dv_type == 1) {
      this.state._notificationSystem.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>Schedule</b> - Updated Successfully .
          </div>
        ),
        level: level,
        position: position,
        autoDismiss: 3,
      });
      setTimeout(() => {
        this.props.history.push("/admin/doctor_schedules");
      }, 3000);
    }
  }

  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleClick(position, message) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>{message}</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var id = JSON.parse(localStorage.getItem("ds_id"));

    GetDocAllUser(obj)
      .then((res) => {
        var users = res.data.data;
        var doc = [];

        for (let i = 0; i < users.length; i++) {
          if (users[i].role == 9) {
            var option = { value: users[i].id, label: users[i].name };
            doc.push(option);
          }
        }
        this.setState({ doctors: doc });
      })
      .catch((err) => {
        console.log(err);
      });

    GetSchedule(obj, id).then((response) => {
      var sch_data = response.data;
      var table_data = this.state.sch_tabledata;

      this.timeslotsconvt();

      var slot_details = sch_data.doctor_schedule;
      for (let i = 0; i < table_data.length; i++) {
        var ind_slot = table_data[i].slot;
        for (let k = 0; k < slot_details.length; k++) {
          if (slot_details[k].week_day == i) {
            var details = {
              slot_id: slot_details[k].id,
              start_time: this.timeslotsconvt(slot_details[k].start_time),
              end_time: this.timeslotsconvt(slot_details[k].end_time),
              duration: slot_details[k].duration,
              week_day: slot_details[k].week_day,
              slot_type: "",
            };
            ind_slot.push(details);
          }
        }
        table_data[i].slot = ind_slot;
      }

      var holidays = sch_data.doctor_holiday;

      for (let i = 0; i < holidays.length; i++) {
        var month = new Date(holidays[i].hdate).getMonth();
        var new_detail = {
          date: holidays[i].hdate,
          is_holiday: holidays[i].is_holiday,
          is_hallmark_day: holidays[i].is_hallmark_day,
          month: month + 1,
        };
        holidays[i] = new_detail;
      }

      this.updatedisplaydetials(table_data);
      this.setState({
        sch_tabledata: table_data,
        sel_docotor: sch_data.id,
        sel_docotor_name: sch_data.name,
        glbSchdule: holidays,
        currentSch: id,
      });
    });

    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
  }

  displaymomentslot = (startTime, endTime, duration, week_day) => {
    var start_date = new Date(startTime);
    var end_date = new Date(endTime);

    let msDifference = end_date - start_date;
    let minutes = Math.floor(msDifference / 1000 / 60);
    var slotlength = (minutes - (minutes % duration)) / duration;
    var timeslots = [];
    var ind_slot = [];

    for (let i = 0; i <= slotlength; i++) {
      var mydate = moment(start_date)
        .add(duration * i, "m")
        .toDate();
      timeslots.push(mydate);
    }

    for (let i = 1; i < timeslots.length; i++) {
      var slotdetails = {
        start_time: timeslots[i - 1],
        end_time: timeslots[i],
        duration: duration,
        week_day: week_day,
        slot_type: "",
      };

      ind_slot.push(slotdetails);
    }

    return ind_slot;
  };

  displatslot = (startTime, endTime, duration) => {
    var start_date = new Date(startTime);
    var end_date = new Date(endTime);

    let msDifference = end_date - start_date;
    let minutes = Math.floor(msDifference / 1000 / 60);
    var slotlength = (minutes - (minutes % duration)) / duration;
    var timeslots = [];
    var pairslots = [];

    for (let i = 0; i <= slotlength; i++) {
      var mydate = moment(start_date)
        .add(duration * i, "m")
        .toDate();
      mydate = `${this.pad(mydate.getHours(), 2)}:${this.pad(
        mydate.getMinutes(),
        2
      )}`;
      var time = mydate
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) {
        time = time.slice(1);
        time[5] = +time[0] < 12 ? " AM" : " PM";
        time[0] = +time[0] % 12 || 12;
      }
      time = time.join("");
      timeslots.push(time);
    }

    for (let i = 1; i < timeslots.length; i++) {
      var pair = `${timeslots[i - 1]} to ${timeslots[i]}`;
      pairslots.push(pair);
    }
    return pairslots;
  };

  pad(num, size) {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
  }

  timeslotsconvt = (timeC) => {
    var time = timeC;
    time = moment(time, ["h:mm A"]).format("HH:mm");
    var today = moment(new Date()).format("YYYY-MM-DD");
    today = `${today} ${time}`;
    return new Date(today);
  };

  timeconversion = (date) => {
    var mydate = date;
    mydate = `${this.pad(mydate.getHours(), 2)}:${this.pad(
      mydate.getMinutes(),
      2
    )}`;
    var time = mydate
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      time = time.slice(1);
      time[5] = +time[0] < 12 ? " AM" : " PM";
      time[0] = +time[0] % 12 || 12;
    }
    return time.join("");
  };

  handleStartDateChange = (date, idx) => {
    var date = new Date(date);
    const minutes = date.getMinutes();
    const roundedMinutes = Math.round(minutes / 5) * 5;
    date.setMinutes(roundedMinutes);
    var data = this.state.sch_tabledata;
    data[this.state.currentslot].slot[idx].start_time = date;

    var start_date = date;
    var end_date = this.timeslotsconvt(
      data[this.state.currentslot].slot[idx].end_time
    );

    data[this.state.currentslot].slot[idx].duration = this.updateduration(
      start_date,
      end_date
    );

    this.setState({
      sch_tabledata: data,
    });
  };

  handleEndDateChange = (date, idx) => {
    var date = new Date(date);
    const minutes = date.getMinutes();
    const roundedMinutes = Math.round(minutes / 5) * 5;
    date.setMinutes(roundedMinutes);
    var data = this.state.sch_tabledata;
    data[this.state.currentslot].slot[idx].end_time = date;

    var end_date = date;
    var start_date = this.timeslotsconvt(
      data[this.state.currentslot].slot[idx].start_time
    );

    data[this.state.currentslot].slot[idx].duration = this.updateduration(
      start_date,
      end_date
    );

    this.setState({
      sch_tabledata: data,
    });
  };

  updateduration = (d1, d2) => {
    let dateOne = new Date(d1);
    let dateTwo = new Date(d2);

    let msDifference = dateTwo - dateOne;
    let minutes = Math.floor(msDifference / 1000 / 60);
    return minutes;
  };

  validate = (name, value) => {
    if (name == "week_days") {
      if (value == "" || value == null || value == undefined) {
        this.setState({
          days_err: <small className="text-danger">Please select day</small>,
        });
      } else {
        this.setState({
          days_err: null,
        });
      }
    }

    if (name == "slot_type") {
      if (value == "" || value == null || value == undefined) {
        this.setState({
          slot_type_err: (
            <small className="text-danger">Please select slot type</small>
          ),
        });
      } else {
        this.setState({
          slot_type_err: null,
        });
      }
    }

    if (name == "duration") {
      if (value == "" || value == null || value == undefined) {
        this.setState({
          duration_err: (
            <small className="text-danger">Please enter duration</small>
          ),
        });
      } else {
        this.setState({
          duration_err: null,
        });
      }
    }
  };

  onChange = (event, idx) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const re = /^[0-9]*$/;
    var data = this.state.sch_tabledata;

    if (name == "duration") {
      if (re.test(value) == true) {
        data[this.state.currentslot].slot[idx].duration = value;
        this.setState({
          sch_tabledata: data,
        });
      }
    }
  };

  onSubmitfinal = () => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var error = false;
    var doc_error = null;
    var table_error = false;

    if (
      this.state.sel_docotor == "" ||
      this.state.sel_docotor == null ||
      this.state.sel_docotor == undefined
    ) {
      error = true;
      doc_error = <small className="text-danger">Please select doctor</small>;
    } else {
      doc_error = "";
    }

    var table_data = this.state.sch_tabledata;
    var doctors = this.state.sel_docotor;
    var new_table_data = [];
    var sel_doctors = [];

    for (let i = 0; i < table_data.length; i++) {
      var slots_detail = table_data[i].slot;
      for (let j = 0; j < slots_detail.length; j++) {
        new_table_data.push(slots_detail[j]);
      }
    }

    for (let i = 0; i < new_table_data.length; i++) {
      var state_time = this.timeconversion(new_table_data[i].start_time);
      var end_time = this.timeconversion(new_table_data[i].end_time);
      new_table_data[i].start_time = state_time;
      new_table_data[i].end_time = end_time;
    }

    if (new_table_data.length == 0) {
      error = true;
      table_error = true;
    }

    if (error) {
      this.setState({
        doc_error: doc_error,
        iserrorSchdule: table_error,
      });
    }

    if (!error) {
      UpdateSchedule(
        obj,
        this.state.currentSch,
        doctors,
        new_table_data,
        this.state.glbSchdule
      )
        .then((res) => {
          if (res.data.success == true) {
            this.handleSuccess(1, "bl");
            localStorage.removeItem("hol_id");
          } else {
            var error_data = this.localdatabackfinal(table_data);
            this.setState({
              sch_tabledata: error_data,
            });
          }
        })
        .catch((err) => {
          var error_data = this.localdatabackfinal(table_data);
          this.setState({
            sch_tabledata: error_data,
          });
          this.handleNetworkError("bl");
        });
    }
  };

  submitCancelOrderModal = () => {
    var convtdata = this.localdataback(this.state.sch_tabledata);

    var error = false;
    var slot_details = convtdata[this.state.currentslot].slot;

    for (let i = 0; i < slot_details.length; i++) {
      if (slot_details[i].start_time > slot_details[i].end_time) {
        error = true;
        break;
      }
    }

    if (!error) {
      if (this.state.isallweekdays == true) {
        for (let i = 0; i < convtdata.length; i++) {
          if (i != this.state.currentslot) {
            convtdata[i].slot = [];
            for (let j = 0; j < slot_details.length; j++) {
              var details = {
                start_time: slot_details[j].start_time,
                end_time: slot_details[j].end_time,
                duration: slot_details[j].duration,
                week_day: i,
                slot_type: "",
                slot_id: 0,
              };
              convtdata[i].slot.push(details);
            }
          }
        }
      }

      this.updatedisplaydetials(convtdata);

      this.setState({
        isallweekdays: false,
        manageslotsshow: error,
        sch_tabledata: convtdata,
        iserror: error,
      });
    }
  };

  closeCancelOrderModal = () => {
    const convtdata = this.localdataback(
      JSON.parse(localStorage.getItem("slot_table_data"))
    );
    this.setState({
      manageslotsshow: false,
      sch_tabledata: convtdata,
      iserror: false,
    });
  };

  editSlot = (idx) => {
    this.localdataconv(this.state.sch_tabledata);
    this.setState({
      manageslotsshow: true,
      currentslot: idx,
      iserrorSchdule: false,
    });
  };

  localdataconv = (datab) => {
    for (let i = 0; i < datab.length; i++) {
      if (datab[i].slot.length > 0) {
        var sloy = datab[i].slot;
        for (let k = 0; k < sloy.length; k++) {
          sloy[k].start_time = this.timeconversion(sloy[k].start_time);
          sloy[k].end_time = this.timeconversion(sloy[k].end_time);
        }
        datab[i].slot = sloy;
      }
    }

    var temp_data = JSON.stringify(datab);
    localStorage.setItem("slot_table_data", temp_data);
  };

  localdataback = (datacb) => {
    var datac = datacb;
    for (let i = 0; i < datac.length; i++) {
      if (datac[i].slot.length > 0) {
        var sloy = datac[i].slot;
        for (let k = 0; k < sloy.length; k++) {
          sloy[k].start_time = this.timeslotsconvt(sloy[k].start_time);
          sloy[k].end_time = this.timeslotsconvt(sloy[k].end_time);
        }
        datac[i].slot = sloy;
      }
    }

    return datac;
  };

  localdatabackfinal = (datacb) => {
    var datac = datacb;
    for (let i = 0; i < datac.length; i++) {
      if (datac[i].slot.length > 0) {
        var sloy = datac[i].slot;
        for (let k = 0; k < sloy.length; k++) {
          sloy[k].start_time = this.timeslotsconvt(sloy[k].start_time);
          sloy[k].end_time = this.timeslotsconvt(sloy[k].end_time);
        }
        datac[i].slot = sloy;
      }
    }

    return datac;
  };

  removeslot = (idx) => {
    var data = this.state.sch_tabledata;
    var slot = data[this.state.currentslot].slot;
    slot.splice(idx, 1);
    this.setState({
      sch_tabledata: data,
    });
  };

  addtimeslot = () => {
    var table_data = this.state.sch_tabledata;
    var slot = table_data[this.state.currentslot].slot;
    var details = {
      start_time: new Date(),
      end_time: moment(new Date()).add(30, "m").toDate(),
      duration: 30,
      week_day: table_data[this.state.currentslot].week_day,
      slot_type: "",
      slot_id: 0,
    };
    slot.push(details);
    this.setState({
      sch_tabledata: table_data,
    });
  };

  updatedisplaydetials = (data) => {
    var table_data = data;
    var displayslots = this.state.timeslots;
    for (let i = 0; i < table_data.length; i++) {
      if (table_data[i].slot.length > 0) {
        var slots = table_data[i].slot;
        var newslot = [];
        for (let k = 0; k < slots.length; k++) {
          var start_time = this.timeconversion(slots[k].start_time);
          var end_time = this.timeconversion(slots[k].end_time);
          newslot.push(`${start_time} to ${end_time}`);
        }
        displayslots[i].slot = newslot;
      } else {
        displayslots[i].slot = [];
      }
    }

    this.setState({
      sch_tabledata: displayslots,
    });
  };

  yesterday = moment().subtract(1, "day");

  disablePastDt = (current) => {
    return current.isAfter(this.yesterday);
  };

  addcategory() {
    this.setState({
      is_add: true,
      iserrorSchdule: false,
    });
  }

  handleStartDateChangeholiday = (date) => {
    this.setState({
      holiday_day: date,
      holiday_day_err: "",
      iserrorHoliday: false,
    });
  };

  handleAllCheckedSlot = (e) => {
    var checked = e.target.checked;
    if (e.target.name == "isHoliday") {
      this.setState({
        isHoliday: checked,
        isCom_err: "",
        iserrorHoliday: false,
      });
    } else if (e.target.name == "isHallMark") {
      this.setState({
        isHallMark: checked,
        isCom_err: "",
        iserrorHoliday: false,
      });
    } else if (e.target.name == "isallweekdays") {
      this.setState({
        isallweekdays: checked,
      });
    }
  };

  removeHoliday = (idx) => {
    var table_date = this.state.glbSchdule;
    table_date.splice(idx, 1);

    this.setState({
      glbSchdule: table_date,
    });
  };

  onCancel = () => {
    this.setState({
      is_add: false,
      holiday_day: new Date(),
      holiday_day_err: "",
      isHoliday: "",
      isHallMark: "",
      isCom_err: "",
    });
  };

  async onSubmit() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var table_data = this.state.glbSchdule;
    var date = moment(this.state.holiday_day).format("YYYY-MM-DD");

    var error = false;
    var com_err = "";
    var holiday_err = "";
    var is_duplicate = false;

    if (
      this.state.holiday_day == "" ||
      this.state.holiday_day == null ||
      this.state.holiday_day == undefined
    ) {
      error = true;
      holiday_err = <small className="text-danger">Please select day</small>;
    } else {
      var support_date = moment(this.state.holiday_day).format("YYYY-MM-DD");
      var current = new Date();
      current = moment(current).format("YYYY-MM-DD");

      if (support_date < current) {
        error = true;
        holiday_err = (
          <small className="text-danger">
            Date should be greater than current date.
          </small>
        );
      } else {
        holiday_err = "";
      }
    }

    if (this.state.isHallMark == false && this.state.isHoliday == false) {
      error = true;
      com_err = (
        <small className="text-danger">
          Please select at least one option.
        </small>
      );
    } else {
      com_err = "";
    }

    for (let i = 0; i < table_data.length; i++) {
      if (date == table_data[i].date) {
        error = true;
        is_duplicate = true;
      }
    }

    this.setState({
      holiday_day_err: holiday_err,
      isCom_err: com_err,
      iserrorHoliday: is_duplicate,
    });

    if (!error) {
      var isHallMark = 0;
      var isHoliday = 0;

      if (this.state.isHallMark == true) {
        isHallMark = 1;
      }
      if (this.state.isHoliday == true) {
        isHoliday = 1;
      }

      var month = new Date(date).getMonth();
      var new_detail = {
        date: date,
        is_holiday: isHoliday,
        is_hallmark_day: isHallMark,
        month: month + 1,
      };

      table_data.push(new_detail);

      this.setState({
        glbSchdule: table_data,
        is_add: false,
        holiday_day: new Date(),
        holiday_day_err: "",
        isHoliday: "",
        isHallMark: "",
        isCom_err: "",
      });
    }
  }

  tabledata = [
    {
      week_day: "0",
      slot: [],
    },
    {
      week_day: "1",
      slot: [],
    },
    {
      week_day: "2",
      slot: [],
    },
    {
      week_day: "3",
      slot: [],
    },
    {
      week_day: "4",
      slot: [],
    },
    {
      week_day: "5",
      slot: [],
    },
    {
      week_day: "6",
      slot: [],
    },
  ];

  tabledata_dis = [
    {
      week_day: "0",
      slot: [],
    },
    {
      week_day: "1",
      slot: [],
    },
    {
      week_day: "2",
      slot: [],
    },
    {
      week_day: "3",
      slot: [],
    },
    {
      week_day: "4",
      slot: [],
    },
    {
      week_day: "5",
      slot: [],
    },
    {
      week_day: "6",
      slot: [],
    },
  ];

  render() {
    return (
      <div className="main-content">
        <input
          style={{ width: "0px", height: "0px", border: "none" }}
          type="text"
          ref={this.coupon_code_error}
        />
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={12}>
              <Card
                content={
                  <form>
                    <Row>
                      <Col>
                        {this.state.iserrorSchdule && (
                          <div
                            className=" alert alert-danger"
                            style={{ margin: "15px" }}
                          >
                            <React.Fragment>
                              <li>
                                Please add at least one time slot for doctor
                                schdule.
                              </li>
                            </React.Fragment>
                          </div>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        sm={12}
                        md={6}
                        style={{ paddingLeft: "10px", paddingRight: "15px" }}
                      >
                        <FormGroup>
                          <ControlLabel>Doctor</ControlLabel>
                          <FormControl
                            type="text"
                            name="week_days"
                            placeholder="Select Doctor"
                            value={this.state.sel_docotor_name}
                            disabled
                          />
                          {/* <select
                            disabled
                            className="react-select info form-control"
                            placeholder="Select Doctor"
                            name="week_days"
                            defaultValue={this.state.sel_docotor_name}
                            // value={this.state.sel_docotor_name}
                            // onChange={(e) =>
                            //   this.setState({
                            //     sel_docotor: e.target.value,
                            //     doc_error: null,
                            //   })
                            // }
                          >
                            {this.state.doctors.map((doc, idd) => (
                              <option key={idd} value={doc.value}>
                                {doc.label}
                              </option>
                            ))}
                          </select> */}
                          {/* {this.state.doc_error} */}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        className="schedular_container"
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                      >
                        <Table>
                          <thead>
                            <tr>
                              <th>Days</th>
                              <th>Doctor Time Slot</th>
                              <th className="text-right">Action</th>
                            </tr>
                          </thead>

                          <tbody>
                            {this.state.loading ? (
                              <tr>
                                <td colSpan="10">
                                  <LoadingSpinner />
                                </td>
                              </tr>
                            ) : (
                              <React.Fragment>
                                {this.state.sch_tabledata.map((tsd, idx) => (
                                  <tr key={idx}>
                                    <td>
                                      <h4>
                                        {tsd.week_day == 1
                                          ? "Monday"
                                          : tsd.week_day == 2
                                          ? "Tuesday"
                                          : tsd.week_day == 3
                                          ? "Wednesday"
                                          : tsd.week_day == 4
                                          ? "Thursday"
                                          : tsd.week_day == 5
                                          ? "Friday"
                                          : tsd.week_day == 6
                                          ? "Saturday"
                                          : tsd.week_day == 0 && "Sunday"}
                                      </h4>
                                    </td>
                                    <td>
                                      {this.state.timeslots.map(
                                        (ts) =>
                                          ts.week_day == tsd.week_day && (
                                            <div className="slot_display_doctor_grid">
                                              {ts.slot.length > 0 ? (
                                                ts.slot.map((tss, idu) => (
                                                  <p key={idu}>{tss}</p>
                                                ))
                                              ) : (
                                                <h5
                                                  style={{
                                                    fontSize: "inherit",
                                                    margin: "0",
                                                  }}
                                                >
                                                  No time slot available
                                                </h5>
                                              )}
                                            </div>
                                          )
                                      )}
                                    </td>
                                    <td className="text-right">
                                      <Button
                                        simple
                                        bsStyle="success"
                                        onClick={() => this.editSlot(idx)}
                                        bsSize="xs"
                                      >
                                        <i className="fa fa-edit" />
                                      </Button>
                                    </td>
                                  </tr>
                                ))}
                              </React.Fragment>
                            )}
                          </tbody>
                        </Table>

                        <div className="holiday_add_update_show">
                          <Row>
                            <Row>
                              <Col md={12}>
                                <Button
                                  style={{
                                    float: "right",
                                    marginRight: "20px",
                                  }}
                                  class="btn-color" //bsStyle="info"
                                  fill
                                  onClick={this.addcategory.bind(this)}
                                >
                                  Add Holiday<i className="fa fa-plus"></i>
                                </Button>
                              </Col>
                            </Row>
                            <br></br>

                            <Col md={12}>
                              <Table responsive>
                                <thead>
                                  <tr>
                                    <th>Date</th>
                                    <th>Is Holiday</th>
                                    <th>Is Hallmark Holiday</th>
                                    <th className="text-right">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.glbSchdule.length < 1 ? (
                                    <tr>
                                      <td colspan="10">
                                        <center>No record found</center>
                                      </td>
                                    </tr>
                                  ) : (
                                    <React.Fragment>
                                      {this.state.glbSchdule.map((cus, idx) => (
                                        <tr key={cus.id}>
                                          <td>
                                            {moment(cus.date).format(
                                              "DD/MM/YYYY"
                                            )}
                                          </td>
                                          <td>
                                            {cus.is_holiday ? "Yes" : "No"}
                                          </td>
                                          <td>
                                            {cus.is_hallmark_day ? "Yes" : "No"}
                                          </td>
                                          <td className="td-actions text-right no-padding">
                                            <Button
                                              simple
                                              bsStyle="danger"
                                              bsSize="xs"
                                              onClick={() =>
                                                this.removeHoliday(idx)
                                              }
                                            >
                                              <i className="fa fa-times" />
                                            </Button>
                                          </td>
                                        </tr>
                                      ))}
                                    </React.Fragment>
                                  )}
                                </tbody>
                              </Table>
                            </Col>
                          </Row>
                        </div>

                        <div className="slot_action_final">
                          <Button
                            onClick={this.onSubmitfinal.bind(this)}
                            className="btn-color"
                            fill
                          >
                            Submit
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>

        <Modal
          className="Manage_time_slot_popup"
          show={this.state.manageslotsshow}
          onHide={this.closeCancelOrderModal}
        >
          <Modal.Header>
            <Modal.Title>Manage Time Slot</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                {this.state.iserror && (
                  <div
                    className=" alert alert-danger"
                    style={{ margin: "15px" }}
                  >
                    <React.Fragment>
                      <li>
                        End time should be greater than start time. Please
                        correct your details and try again.
                      </li>
                    </React.Fragment>
                  </div>
                )}
              </Col>
            </Row>
            <Row
              style={{
                display: "flex",
                gap: "15px",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
              <Checkbox
                number={2}
                checked={this.state.isallweekdays}
                label="Apply to all weekdays?"
                name="isallweekdays"
                onChange={(e) => this.handleAllCheckedSlot(e)}
                value={this.state.isallweekdays}
                className="is_day_off_checkbox"
              />

              <Button
                style={{ float: "right" }}
                className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
                onClick={this.addtimeslot.bind(this)}
              >
                Add Slot <i className="fa fa-plus"></i>
              </Button>
            </Row>

            <Table responsive>
              <thead>
                <tr>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Duration(Min)</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {this.state.loading ? (
                  <tr>
                    <td colSpan="10">
                      <LoadingSpinner />
                    </td>
                  </tr>
                ) : (
                  <React.Fragment>
                    {this.state.sch_tabledata[this.state.currentslot] &&
                    this.state.sch_tabledata[this.state.currentslot].slot
                      .length > 0 ? (
                      this.state.sch_tabledata[this.state.currentslot].slot.map(
                        (tsd, idx) => (
                          <tr key={idx}>
                            <td>
                              <FormGroup className="list_sch_time_list">
                                <Datetime
                                  format="y-MM-dd h:mm:ss"
                                  timeFormat={true}
                                  dateFormat={false}
                                  inputProps={{ placeholder: "Start Time" }}
                                  defaultValue={tsd.start_time}
                                  closeOnSelect={true}
                                  name="startTime"
                                  value={tsd.start_time}
                                  timeConstraints={{ minutes: { step: 5 } }}
                                  onChange={(date) =>
                                    this.handleStartDateChange(date, idx)
                                  }
                                  className={`datetime-timeselect`}
                                />
                                {this.state.startTime_err}
                              </FormGroup>
                            </td>
                            <td>
                              <FormGroup className="list_sch_time_list">
                                <Datetime
                                  format="y-MM-dd h:mm:ss"
                                  timeFormat={true}
                                  dateFormat={false}
                                  inputProps={{ placeholder: "End Time" }}
                                  defaultValue={tsd.end_time}
                                  closeOnSelect={true}
                                  name="endTime"
                                  value={tsd.end_time}
                                  timeConstraints={{ minutes: { step: 5 } }}
                                  onChange={(date) =>
                                    this.handleEndDateChange(date, idx)
                                  }
                                  className={`datetime-timeselect`}
                                />
                                {this.state.endTime_err}
                              </FormGroup>
                            </td>
                            <td>
                              <div className="Duration_time_slot_container">
                                <p>{tsd.duration > 0 ? tsd.duration : "-"}</p>
                              </div>
                            </td>
                            <td>
                              <Button
                                simple
                                bsStyle="danger"
                                onClick={() => this.removeslot(idx)}
                                bsSize="xs"
                              >
                                <i className="fa fa-times" />
                              </Button>
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <p className="no_slot_avail_text">No slot available</p>
                    )}
                  </React.Fragment>
                )}
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={this.submitCancelOrderModal}
              bsStyle="success"
              fill
            >
              Submit
            </Button>
            &nbsp;
            <Button onClick={this.closeCancelOrderModal} bsStyle="info" fill>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          className=""
          show={this.state.is_add}
          onHide={() => this.setState({ is_add: false })}
        >
          <Modal.Header>
            <Modal.Title>Add Holiday</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                {this.state.iserrorHoliday && (
                  <div
                    className=" alert alert-danger"
                    style={{ margin: "15px" }}
                  >
                    <React.Fragment>
                      <li>Holiday date is already available.</li>
                    </React.Fragment>
                  </div>
                )}
              </Col>
            </Row>

            <FormGroup>
              <ControlLabel>Date</ControlLabel>
              <Datetime
                format="y-MM-dd h:mm:ss"
                timeFormat={false}
                dateFormat={true}
                inputProps={{ placeholder: "Select Date" }}
                defaultValue={this.state.holiday_day}
                closeOnSelect={true}
                name="holiday_day"
                value={this.state.holiday_day}
                onChange={this.handleStartDateChangeholiday}
                className={`datetime-timeselect`}
                isValidDate={this.disablePastDt}
              />
              {this.state.holiday_day_err}
            </FormGroup>

            <FormGroup>
              <Checkbox
                number={2}
                checked={this.state.isHoliday}
                label="Is Holiday ?"
                name="isHoliday"
                onChange={(e) => this.handleAllCheckedSlot(e)}
                value={this.state.isHoliday}
                className="is_day_off_checkbox"
              />
            </FormGroup>

            <FormGroup>
              <Checkbox
                number={1}
                checked={this.state.isHallMark}
                label="Is Hallmark Holiday ?"
                onChange={(e) => this.handleAllCheckedSlot(e)}
                name="isHallMark"
                value={this.state.isHallMark}
                className="is_day_off_checkbox"
              />
            </FormGroup>
            {this.state.isCom_err}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => this.onSubmit()} bsStyle="success" fill>
              Add
            </Button>
            &nbsp;
            <Button onClick={() => this.onCancel()} bsStyle="info" fill>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default EditSchedule;
